<template>
  <div class="max-w-md mx-auto w-full">
    <!-- <h1 class="text-2xl font-semibold text-gray-900 mb-2">Add a few ideas</h1>
    <p class="text-gray-600 mb-8">
      In the future, your users will be adding these. To get started, add a few ideas to
      <span class="font-medium">{{ board.name }}</span>.
    </p> -->

    <form @submit.prevent="createPosts()">
      <div class="space-y-6">
        <div v-for="(post, type) in posts" :key="type">
          <div class="flex items-baseline justify-between gap-2 mb-1">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              {{ post.label }}
            </label>
            <div class="text-xs">
              <span 
                class="px-2 py-1 rounded-lg text-sm"
                :style="getStatusStyle(post.status)"
              >
                {{ getStatusLabel(post.status) }}
              </span>
            </div>
          </div>
          <input
            type="text"
            v-model="value[type].title"
            :ref="type === 'first' ? 'postInput' : null"
            :placeholder="post.placeholder"
            class="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-shadow"
          />
        </div>

        <button
          type="submit"
          :disabled="isLoading"
          class="w-full bg-[#F54239] min-h-[48px] text-white py-3 px-4 rounded-xl font-medium hover:brightness-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="!isLoading" class="flex items-center justify-center">
            Continue
            <simple-svg :filepath="NextIcon" class="ml-2 w-4 h-4" />
          </span>
          <simple-svg v-else :filepath="LoaderIcon" class="animate-spin w-5 h-5 mx-auto" />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import NextIcon from "../images/icons/arrow-right.svg";
import LoaderIcon from "../images/icons/loader.svg";

export default {
  props: ["value", "project", "board"],

  data() {
    return {
      isLoading: false,
      NextIcon,
      LoaderIcon,
      error: "",
      posts: {
        first: {
          label: "What have you completed recently?",
          placeholder: "e.g. Implement chat support",
          status: "done"
        },
        second: {
          label: "What's in progress right now?",
          placeholder: "e.g. Dark mode",
          status: "in_progress"
        },
        third: {
          label: "What's planned next?",
          placeholder: "e.g. Integrate with payment gateway",
          status: "planned"
        }
      }
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.postInput.focus();
    });
  },

  methods: {
    createPosts() {
      this.isLoading = true;
      let value = this.value;

      // if none filled, then don't bother
      if (!value.first.title && !value.second.title && !value.third.title) {
        if(window.innerWidth <= 480){
            window.location.replace(this.projectUrl+"?track_signup=true");
          }else{
            this.$emit("submit");
          }
        return;
      }

      let formData = new FormData();

      if (value.first.title) {
        formData.append("posts[first][title]", value.first.title);
        formData.append("posts[first][status]", value.first.status);
      }

      if (value.second.title) {
        formData.append("posts[second][title]", value.second.title);
        formData.append("posts[second][status]", value.second.status);
      }

      if (value.third.title) {
        formData.append("posts[third][title]", value.third.title);
        formData.append("posts[third][status]", value.third.status);
      }

      Rails.ajax({
        url: `/projects/${this.project.id}/boards/${this.board.id}`,
        type: "POST",
        data: formData,
        dataType: "json",
        beforeSend: function() {
          return true;
        },
        success: data => {
          if(window.innerWidth <= 480){
            window.location.replace(this.projectUrl+"?track_signup=true");
          }else{
            this.$emit("submit");
          }
        },
        error: (data, status) => {
          this.error = data.error
          this.isLoading = false;
          console.log(data);
        }
      });
    },

    getStatusStyle(status) {
      const styles = {
        done: {
          color: 'rgb(16, 185, 129)',
          backgroundColor: 'rgba(16, 185, 129, 0.1)'
        },
        in_progress: {
          color: 'rgb(253, 180, 2)',
          backgroundColor: 'rgba(253, 180, 2, 0.1)'
        },
        planned: {
          color: 'rgb(24, 191, 255)',
          backgroundColor: 'rgba(24, 191, 255, 0.1)'
        }
      };
      return styles[status] || {};
    },

    getStatusLabel(status) {
      const labels = {
        done: 'Done',
        in_progress: 'In progress',
        planned: 'Planned'
      };
      return labels[status] || status;
    }
  },

  computed: {
    projectUrl() {
      return (
        "http://" +
        this.project.url +
        "." +
        document.querySelector('meta[name="root-domain"]').content
      );
    },
  },
};
</script>

<style></style>
